import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {Auth, Unsubscribe, User} from "@angular/fire/auth";

@Directive({
  selector: '[appRoleBasedDisplay]',
  standalone: true
})
export class RoleBasedDisplayDirective {

  role: string;
  display = false;
  private userSubscription: Unsubscribe;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private auth: Auth
  ) {
    this.userSubscription = this.auth.onAuthStateChanged(user => this.updateView(user));
  }

  @Input() set appRoleBasedDisplay(role: string) {
    this.role = role;
  }

  private async updateView(user) {
    if (!user) {
      this.viewContainer.clear();
      this.display = false;
    }
    const hasRole = await this.hasRole(user, this.role)

    if (hasRole) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.display = true;
    } else {
      this.viewContainer.clear();
      this.display = false;
    }
  }

  private async hasRole(user: User, role: string): Promise<boolean> {
    if (!user) {
      return false;
    }
    const tokenResult = await user.getIdTokenResult();
    return tokenResult.claims.hasOwnProperty(role);
  }

  ngOnDestroy() {
    this.userSubscription();
  }

}
